module.exports = __webpack_public_path__ + "static/media/logo-dark.4f2e3904.svg";